// src/pages/ProductsPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import ProductForm from '../components/ProductForm';
import ProductList from '../components/ProductList';

const ProductsPage = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [categories, setCategories] = useState([]);
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('http://localhost:8005/categories');
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleProductAdded = (product) => {
    console.log('Product added:', product);
    setSelectedProduct(null);
    refreshProducts();
    handleAlert('Product created successfully!', 'success');
  };

  const handleProductUpdated = () => {
    setSelectedProduct(null);
    refreshProducts();
    handleAlert('Product updated successfully!', 'success');
  };

  const handleProductDeleted = () => {
    setSelectedProduct(null);
    refreshProducts();
    handleAlert('Product deleted successfully!', 'success');
  };

  const handleEditProduct = (product) => {
    setSelectedProduct(product);
  };

  const handleAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert({ message: '', type: '' }), 3000);
  };

  const refreshProducts = useCallback(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, []);

  return (
    <div className="container mt-4">
      {/* <h1>Manage Products</h1> */}
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <ProductForm
        product={selectedProduct}
        categories={categories}
        onProductAdded={handleProductAdded}
        onProductUpdated={handleProductUpdated}
        onAlert={handleAlert}
      />
      <ProductList
        key={refreshKey}
        onProductDeleted={handleProductDeleted}
        onEditProduct={handleEditProduct}
      />
    </div>
  );
};

export default ProductsPage;
